<template>
    <div class="card">
        <v-data-table :headers="headers" :items="itemsproductos" :search="search" class="elevation-1">
            <template v-slot:top>

                <v-row class="pa-3" dense>
                    <v-col cols="12" md="2">
                        <span class="font-weight-bold">Carga Masiva Productos</span>
                    </v-col>
                    <v-col cols="12" md="5">
                        <!-- <v-divider class="mx-4" inset  vertical ></v-divider> -->
                        <v-text-field v-model="search" type="text" append-icon="mdi-magnify"
                            label="Buscar por producto..." dense outlined hide-details></v-text-field>

                    </v-col>
                    <v-col cols="8" md="5" class="text-center" title="Seleccione archivo de excel con los productos que desea cargar">
                        <v-file-input chips accept=".xlsx, .xls" label="Cargar productos en Excel"
                            
                            @change="onFileChange"></v-file-input>
                    </v-col>
                </v-row>


            </template>
            <template v-slot:[`item.tipo`]="{ item }">
                <p v-text="item.tipo"></p>
            </template>         
            <template v-slot:no-data>
                <h2>No hay productos para cargar masivamente</h2>
            </template>
        </v-data-table>
        <v-sheet style="margin: auto; padding: 6px;" class="mt-1">
            <div style="display: flex;gap: 20px;">
                <v-btn color="success" dark @click="postItem" title="Cancelar carga de productos">
                            <v-icon>mdi mdi-database-sync</v-icon>
                            Procesar
                </v-btn>

                <v-btn color="error" dark @click="close" title="Cancelar carga de productos">
                            <v-icon>mdi-close</v-icon>
                            Cancelar
                </v-btn>
            </div>
        </v-sheet>
    </div>
</template>

<script>

import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'
import { importExcel } from '../importExcel';
import axios from 'axios'
export default {
    name: 'Productos',
    data: () => ({
        file: false,
        search: '',
        itemsproductos: [],
        idestablecimiento: 1,
        headers: [
            { text: 'Cod.', align: ' d-none d-sm-table-cell', value: 'codigo' },
            { text: 'Nombre', value: 'nombre', width: '50%' },
            { text: 'Precio Compra', align: 'center', value: 'preciocompra' },
            { text: 'Precio Sugerido', align: 'center', value: 'preciosugerido' },
            { text: 'Precio Minimo', align: 'center', value: 'preciominimo' },
        ]
    }),

    computed: {
        ...mapGetters(['getTokenUser','getUrlApi'])
    },

    methods: {
        async initialize() {
        },
        async onFileChange(file) {
            const selectedFile = file 
            if (selectedFile && (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || selectedFile.type === "application/vnd.ms-excel")) {
                this.file = selectedFile;
                this.error = null;
               await this.loadExcel(this.file);
            }
        },
        async loadExcel(file){
            try {
                const productos = await importExcel(file);
                this.itemsproductos = productos;
            } catch (error) {
                console.error(error);
            }
        },
        deleteItem(idarticulo) {

            Swal.fire({
                title: 'Esta Seguro?',
                text: "El registro será Desactivado!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, Desactivar!',
                cancelButtonText: 'Cancelar!'
            }).then((result) => {
                if (result.isConfirmed) {
                    console.log(idarticulo)
                    //Procedimiento para eliminarlo
                    //this.cambiarestado("Eliminado",idarticulo)
                }
            })


        },
        async postItem(){
            if(this.itemsproductos.length<1){
                Swal.fire('No hay productos para procesar','','error')
                return
            } 
            try {
                await axios.post(`${this.getUrlApi}/articulos/masivo`,this.itemsproductos,this.getTokenUser)
                await this.$store.dispatch('setProductos')
                this.alertDone()
                this.close()
            } catch (error) {
                console.log(error)
                this.alertError()
            }

        },
        close(){
            this.$emit('cerrartable',false)
            this.file=null;
            this.itemsproductos= []
        },
        //Notificaciones Swal
        alertDone() {
            Swal.fire({
                icon: 'success',
                title: 'Realizado',
                showConfirmButton: false,
                timer: 1500
            })
        },
        alertError() {
            Swal.fire({
                icon: 'error',
                title: 'No pudo realizarse la solicitud',
                showConfirmButton: false,
                timer: 1500
            })
        }
    },


}
</script>
<style lang="css">
.v-data-table td {
    font-size: 12px !important;
    height: 35px !important;
}
</style>